<template>
  <div class="m-3 mb-4">
    <div id="accordion">
      <div class="card">
        <div class="card-header" id="headingOne">
          <h5 class="mb-0">
            <button class="btn btn-link collapsed" data-toggle="collapse" aria-expanded="false"
              @click="alterarIcone(`icon-${codigo}`, codigo)" :data-target="`#${codigo}`">
              <i :id="`icon-${codigo}`" class="fa fa-angle-right" aria-hidden="false"></i>
              <span> {{ titulo }} </span>
            </button>

            <div v-if="clone" class="icon-content">
              <i v-if="!descricao" @click="confirmacaoExclusaoMenu(codigo, titulo)" style="font-size: 13px !important;float:right"
                class="fa-solid fa-trash"></i>
            </div>
          </h5>
        </div>

        <div :id="codigo" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
          <div class="card-body">
            <div class="container mt-2 mb-4">
              <div v-if="clone" class="icon-container">
                <i @click="openModalServico(codigo)" class="fas fa-plus plus-icon"></i>
              </div>
            </div>

            <div :id="`accordion-${servicoMenu.codigo}-services`" model="selectedListasServicos"
              v-for="servicoMenu in listaDadosServicos" :key="servicoMenu.codigo" :value="servicoMenu.descricao">
              <div>
                <ServiceTabs :fluxoMenu="fluxoTela" :menu="menu" :descricao="servicoMenu.descricao"
                  :codigoMenu="String(codigo)" :codigo="String(servicoMenu.codigo)" @onAction="onActionInComponent"
                  @onActionAtribute="onActionAtributeInComponent" />
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- O Modal Rest Soap -->
    <div v-if="showModal" class="modal modal-servico fade" id="myModal" tabindex="-1"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" style="font-weight: 600;">Adicionar Serviço</h5>
            <button type="button" class="btn-close" data-mdb-dismiss="modal" @click="closeModal"
              aria-label="Close"></button>
          </div>

          <div class="modal-body">
            <div class="col-12 col-sm-12">
              <div class="form-outline mb-1 mt-2">
                <div class="textarea-container mb-5">
                  <label class="green-label" for="textareaId">Nome:</label>
                  <input id="nomeModal" v-model="servicoApi.menu" class="input-modal">
                </div>
              </div>

              <div class="form-outline">
                <div class="textarea-container mt-4">
                  <label for="exampleSelect" class="green-label">Método HTTP:</label>
                  <select v-model="servicoApi.requestType" class="form-select select-modal" id="tipoAutenticacao" >
                    <option value="Selecione" selected>Selecione</option>
                    <option id="requestType" value="G">GET</option>
                    <option id="requestType" value="P">POST</option>
                    <option id="requestType" value="P">PUT</option>
                    <option id="requestType" value="D">DELETE</option>
                  </select>
                </div>
              </div>

              <div class="form-outline mt-4">
                <div class="textarea-container mt-4">
                  <label class="green-label" for="textareaId">URL:</label>
                  <input id="urlModal" v-model="servicoApi.url" class="input-modal">
                </div>
              </div>

              <div class="form-outline">
                <div class="textarea-container mt-4">
                  <label class="green-label" for="textareaId">Método:</label>
                  <input id="metodoModal" v-model="servicoApi.metodo" class="input-modal">
                </div>
              </div>

              <div class="form-outline mb-1">
                <div class="textarea-container mt-4 mb-5">
                  <label class="green-label" for="textareaId">Introdução:</label>
                  <textarea id="introducaoModal" v-model="servicoApi.introducao" rows="2" class="text-area-modal">
                  </textarea>
                </div>
              </div>

            </div>
          </div>

          <div class="mt-4" role="group" aria-label="Basic example">
            <div class="row m-1">
              <div class="col-5">
                <button @click="closeModal" type="button" id="vendas" class="footer-button btn btn-primary"
                  style="width: 105% !important;" data-mdb-ripple-init>CANCELAR</button>
              </div>
              <div class="col-1">
              </div>
              <div class="col-3">
                <button @click="salvarNovoServico()" type="button" id="gestao-carteira"
                  style="width: 205% !important;color:white !important" class="footer-button btn btn-primary active"
                  data-mdb-ripple-init>SALVAR</button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>



</template>

<script>
import * as alertUtils from '@/utils/alert';
import * as loaderUtils from '@/utils/loader'
import $ from 'jquery'; // Importando jQuery
import 'mdb-ui-kit'; // Importando o JavaScript do MDB
import * as ajaxUtils from '@/utils/ajax';
import ServiceTabs from './ServiceTabs.vue';
import * as validadorUtils from '@/utils/validador';

export default {
  name: "MenuTabs",
  data() {
    return {
      clone: false,
      showModal: false,
      showModalAddParametros: false,
      showModalEditParametros: false,
      selectedListasServicos: "",
      selectedListasServicosCampo: "",
      selectedListasServicosAtributos: "",
      requestType: "",
      listaDadosServicos: [],
      listaDadosServicoCampos: [],
      listaDadosServicoAtributos: [],
      listaDadosServicoAtributosHierarquia: [],
      atualDataEditParametros: [],
      atributo: {
        tipo: "",
        nome: "",
        obrigatorio: "",
        formato: "",
        lista: "",
        descricao: "",
        observacao: "",
        idServicoApi: "",
        indexPai: "",
        disabledTipo: false,
      },
      servicoApi: {
        menu: "",
        introducao: "",
        url: "",
        metodo: "",
        requestType: "",
        idCatalogoApi: "",
        codigoMenuPai: ""
      },
      codigoMenuPai: "",
      tempTipo: "",
      tempNome: "",
      tempDescricao: "",
      tempDominio: "",
      tempObservacao: "",
      fluxoTela: {},
    };
  },
  props: {
    titulo: {
      type: String,
      required: true
    },
    descricao: {
      type: String,
      required: false
    },
    codigo: {
      type: String,
      required: true
    },
    subMenu: {
      type: Boolean,
      required: false
    },
    tipo: {
      type: String,
      required: false
    },
    menu: {
      type: String,
      required: false
    }
  },
  components: {
    ServiceTabs
  },
  methods: {
    async onActionAtributeInComponent() {
      // Recarrega a página com a URL modificada
      location.reload();

      setTimeout(() => {
        $('#rest2').click();
      }, 2000);
    },
    async onActionInComponent() {
      // Acesse o hash da URL
      const hash = window.location.hash;

      // Remova a primeira barra ("/") e separe a string com base nas barras
      const idCatalogo = hash.split('/').pop();

      this.pesquisarServicoMenu(idCatalogo, this.codigo);
    },
    async toggleCollapse(event) {
      // Fecha todos os collapses
      const allCollapses = document.querySelectorAll('.collapse');
      allCollapses.forEach(function (collapse) {
        if (collapse !== document.querySelector(event.target.getAttribute('data-target'))) {
          $(collapse).collapse('hide');
        }
      });

      // Abre o collapse clicado
      const targetCollapse = document.querySelector(event.target.getAttribute('data-target'));
      $(targetCollapse).collapse('toggle');
    },
    async mudarEstadoInput(event) {
      // Quando o valor do input mudar, marca a flag como true
      if (event.target.value !== this.valorAnterior) {
        this.mudou = true;
      }
    },
    async mudarTipo(status, metodo) {
      const formato = metodo === 1 ? 'formatoAdicionar' : 'formato';

      if (status) {
        $(`#${formato}`).prop("disabled", true);

        setTimeout(function () {
          $(`#${formato}`).val('O');
        }, 40);
      } else {
        $(`#${formato}`).prop("disabled", false);

        if (metodo === 1) {
          setTimeout(function () {
            $(`#${formato}`).val('');
          }, 40);
        }
      }
    },
    async validarTipo(selectName) {
      const tipo = $(`#${selectName}`).val();

      const metodo = selectName.includes("Adicionar") ? 1 : 0;

      tipo === 'O' ? this.mudarTipo(true, metodo) : this.mudarTipo(false, metodo);
    },
    async mudarRequestType() {
      const tipoRequest = $('#requestType').val();
      const idServicoApi = $('#idServicoApi').val();
      const introducao = $('#introducao').val();
      const metodo = $('#metodo').val();
      const url = $('#url').val();

      let tipoRequestFormatado = tipoRequest.slice(0, 1).toUpperCase();

      if (tipoRequest === "PUT") tipoRequestFormatado = "T";

      const bodyData = {
        "introducao": String(introducao),
        "idServicoApi": String(idServicoApi),
        "url": String(url),
        "metodo": String(metodo),
        "requestType": String(tipoRequestFormatado)
      };

      let jsonRequest;

      jsonRequest = JSON.stringify(bodyData);

      await ajaxUtils.postOK(
        '/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/salvar-dados-prinicipais-servico',
        jsonRequest,
        '',
        ''
      );
    },
    async salvarPosFoco(event) {
      const tipoRequest = $('#requestType').val();
      const idServicoApi = $('#idServicoApi').val();
      const introducao = $('#introducao').val();
      const metodo = $('#metodo').val();
      const url = $('#url').val();

      const codigoXmlFimOut = $('#codigoXmlFimOut').val();
      const codigoXmlInicioOut = $('#codigoXmlInicioOut').val();
      const codigoXmlFim = $('#codigoXmlFim').val();
      const codigoXmlInicio = $('#codigoXmlInicio').val();

      let tipoRequestFormatado = tipoRequest.slice(0, 1).toUpperCase();

      if (tipoRequest === "PUT") tipoRequestFormatado = "T";

      const bodyData = {
        "codigoXmlFimOut": String(codigoXmlFimOut),
        "codigoXmlInicioOut": String(codigoXmlInicioOut),
        "codigoXmlFim": String(codigoXmlFim),
        "codigoXmlInicio": String(codigoXmlInicio),
        "introducao": String(introducao),
        "idServicoApi": String(idServicoApi),
        "url": String(url),
        "metodo": String(metodo),
        "requestType": String(tipoRequestFormatado)
      };

      let jsonRequest;

      jsonRequest = JSON.stringify(bodyData);

      if (this.mudou) {
        await ajaxUtils.postOK(
          '/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/salvar-dados-prinicipais-servico',
          jsonRequest,
          '',
          ''
        );

        this.mudou = false; // Resetando a flag
      }
    },

    

    async removerAtributo(idServicoApi, index) {
      try {
        const url = `/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/excluir-atributo/${idServicoApi}/${index}`;

        const response = await fetch(url, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json"
          }
        });

        if (response.ok) {
          const result = await response.text();
          this.closeModal();
          alertUtils.alertSuccess("Atributo removido com sucesso!");
          this.$emit('onAction', this.codigo);
        } else {
          const error = await response.text();
        }
      } catch (error) {
        console.error("Erro ao excluir o parâmetro:", error);
      }
    },

    async confirmacaoExclusaoMenu(codigoMenu, titulo) {
      loaderUtils.addLoarder();
      alertUtils.alertConfirmacaoTop(`Deseja excluir o menu ${titulo}?`).then(
        (result) => {
          if (result) {
            this.excluirMenu(codigoMenu);
          } else {
              loaderUtils.removeLoader();
          }
        }
      );
    },

    async excluirMenu(codigoMenu) {
      const url = window.location.href;
      const idCatalogo = url.substring(url.lastIndexOf('/') + 1);

      const urlApi = '/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/excluir-menu-catalogo/' + codigoMenu + '/' + String(idCatalogo);

      const requestAjax = await ajaxUtils.getOK(
        urlApi,
        '',
        '',
        ''
      );


      if (requestAjax) {
        this.$emit('onAction', { type: 'MENU_DELETADO', codigoMenu: codigoMenu });

        alertUtils.alertSuccess("Menu excluído com sucesso!");
      } else {
        alertUtils.alertSuccess("Erro ao excluir Menu!");
      }

      return requestAjax;
    },

    async resetFormService() {
      // // Resetando os campos de <input> e <textarea>
      $('#urlModal').val('');
      $('#nomeModal').val('');
      $('#metodoModal').val('');
      $('#introducaoModal').val('');
    },
    async openModalServico(codigo) {
      this.showModal = true;
      this.codigoMenuPai = codigo;

      try {
        setTimeout(async () => {
          const modalElement = document.querySelector('.modal-servico');
          const modalInstance = await new mdb.Modal(modalElement);

          await modalInstance.show();

          await this.resetFormService();

          $('.icon-container').css('display', 'unset')
        }, 200); // 200 milissegundos = 0.2 segundos
      } catch (error) {
        console.log(error)
      }
    },
    async editarNovoParametro() {
      try {
        this.atributo.tipo = this.tempTipo;
        this.atributo.nome = this.tempNome;

        // ID do serviço e índice do pai
        const idServicoApi = this.atributo.idServicoApi;
        const indexPai = this.atributo.ordem;
        const formato = $("#formato").val()
        const payload = {
          entrada: this.atributo.entrada,
          tipo: this.atributo.tipo,
          nome: this.atributo.nome,
          obrigatorio: this.atributo.obrigatorio,
          formato: formato,
          lista: this.atributo.lista,
          descricao: this.atributo.descricao,
          dominio: this.atributo.dominio,
          observacao: this.atributo.observacao
        };

        const url = `/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/alterar-atributo/${idServicoApi}/${indexPai}`;

        const editarParametro = await ajaxUtils.postOK(
          url,
          JSON.stringify(payload),
          'Parâmetro salvo com sucesso!',
          ''
        );

        if (editarParametro === true) {
          this.closeModal();
          this.$emit('onAction', this.codigo);
        }

        this.$emit('onActionAtribute', 'rest');
      } catch (error) {
        console.error("Erro ao salvar o parâmetro:", error);
      }
    },
    async salvarNovoParametro() {
      try {
        // ID do serviço e índice do pai
        const idServicoApi = this.atributo.idServicoApi;
        const indexPai = this.atributo.indexPai ? this.atributo.indexPai : -1;
        const nome = $('#nomeModalAdicionar').val();
        const descricao = $('#descricaoModalAdicionar').val();
        const tipo = $('#tipoAutenticacaoSelectAdicionar').val();
        let entrada = $('#objetoId').val()

        switch (entrada) {
          case "Header":
            entrada = "H"
            break;
          case "Entrada":
            entrada = "E"
            break;
          case "Get":
            entrada = "G"
            break;
          case "Form":
            entrada = "F"
            break;
          case "Saida":
            entrada = "S"
            break;
          case "Alerta":
            entrada = "A"
            break;
          case "Erro":
            entrada = "W"
            break;
          case "Body":
            entrada = "B"
            break;
        }

        const payload = {
          entrada: entrada,
          tipo: tipo,
          nome: nome,
          obrigatorio: this.atributo.obrigatorio,
          formato: this.atributo.formato,
          lista: this.atributo.lista,
          descricao: descricao,
          dominio: this.tempDominio,
          observacao: this.tempObservacao
        };
        const url = `/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/incluir-atributo/${idServicoApi}/${indexPai}`;

        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(payload)
        });

        if (response.ok) {
          const result = await response.text();
          this.closeModal();
          alertUtils.alertSuccess("Parâmetro salvo com sucesso!");
          this.$emit('onActionAtribute', 'rest');
        } else {
          const error = await response.text();
        }
      } catch (error) {
        console.error("Erro ao salvar o parâmetro:", error);
      }
    },
    async openModalAddParametros(tipo, idServicoApi, indexPai) {
      this.requestType = tipo ? tipo : "";

      this.atributo.idServicoApi = idServicoApi || "";
      this.atributo.indexPai = indexPai !== null ? indexPai : "";
      this.atributo.disabledTipo = tipo !== "";
      this.showModalAddParametros = true;

      try {
        setTimeout(async () => {
          const modalElement = document.querySelector('.modal-add-parametros');
          const modalInstance = await new mdb.Modal(modalElement);

          await modalInstance.show();

          this.resetForm();
        }, 200); // 200 milissegundos = 0.2 segundos
      } catch (error) {
        console.log(error)
      }
    },
    async openModalEditarParametros(tipo, idServicoApi, modalData) {
      switch (tipo) {
        case 'Entrada':
          tipo = 'E';
          break;
        case 'Header':
          tipo = 'H';
          break;
        case 'Get':
          tipo = 'G';
          break;
        case 'Saida':
          tipo = 'S';
          break;
        case 'Alerta':
          tipo = 'W';
          break;
        case 'Erro':
          tipo = 'U';
          break;
        case 'Body':
          tipo = 'B';
          break;
        default:
          break;
      }

      this.requestType = tipo ? tipo : "";

      this.showModalEditParametros = true;
      this.atributo = modalData;
      this.atributo.idServicoApi = idServicoApi;
      this.atualDataEditParametros = modalData;

      this.tempTipo = this.atributo.tipo;
      this.tempNome = this.atributo.nome;

      try {
        setTimeout(async () => {
          const modalElement = document.querySelector('.modal-edit-parametros');
          const modalInstance = await new mdb.Modal(modalElement);

          await modalInstance.show();

          $("#formato").val(this.atributo.formato);

          this.validarTipo('tipoAutenticacaoSelect');
        }, 200); // 200 milissegundos = 0.2 segundos
      } catch (error) {
        console.log(error);
      }
    },
    async excluirAgrupamento(idServicoApi, index) {
      this.removerAtributo(idServicoApi, index)

    },
    async closeModal() {
      this.showModal = false;

      this.servicoApi = {
        menu: '',
        requestType: '',
        url: '',
        metodo: '',
        introducao: ''
      };

      $('.modal').hide();
      $('.modal-backdrop').hide();
      $('body').css('overflow', 'auto'); // Ativa a barra de rolagem
    },
    async resetForm() {
      // Resetando os campos <select>
      $('#tipoAutenticacao').val('Selecione');
      // Resetando os campos <select>
      $('#tipoAutenticacaoSelect').val('Selecione');
      $('#tipoAutenticacaoSelectAdicionar').val('Selecione');
      // Resetando os campos <select>
      $('#formato').val('Selecione');
      $('#formatoAdicionar').val('Selecione');

      // Resetando os campos de <input> e <textarea>
      $('#descricaoModalAdicionar').val('');
      $('#dominioModalAdicionar').val('');
      $('#observacaoModalAdicionar').val('');

      $('#nomeModalAdicionar').val('');

      $('#obrigatorioId').val('');

      $('#formato').val('');

      $('#listaId').val('');

      $('#tipoAutenticacaoSelect').val('');
    },
    async salvarFluxo(codigo) {
      this.fluxoTela = { menuAcessado: codigo }
    },
    async alterarIcone(iconId, codigo) {
      this.salvarFluxo(codigo);

      // Fecha todos os outros ícones
      $('i[id^="icon-"]').each(function () {
        const currentId = $(this).attr('id');
        if (currentId !== iconId) {
          $(this).removeClass('fa-angle-down').addClass('fa-angle-right');
        }
      });

      // Alterna o ícone clicado
      const iconeSetadoDown = $('#' + iconId).hasClass('fa-angle-down');
      const iconeSetadoRight = $('#' + iconId).hasClass('fa-angle-right');

      if (iconeSetadoRight === true) {
        $('#' + iconId).removeClass('fa-angle-right').addClass('fa-angle-down');

        document.querySelectorAll('.collapse.show').forEach(el => {
          const instance = mdb.Collapse.getOrCreateInstance(el);
          instance.hide();
        });
      } else if (iconeSetadoDown === true) {
        $('#' + iconId).removeClass('fa-angle-down').addClass('fa-angle-right');
      }
    },
    async buscarServico(idServico) {
      loaderUtils.addLoarder();

      let urlApi;
      let method;
      let requestOptions;

      urlApi = '/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/consultar-servico/' + idServico;
      method = 'GET';

      requestOptions = {
        method: method
      };

      try {
        fetch(urlApi, requestOptions)
          .then(async (response) => {
            if (response.ok) {
              return response.json();
            } else {
              throw new Error('Fechar');
            }
          })
          .then(async (data) => {
            if (Array.isArray(this.listaDadosServicoCampos) && this.listaDadosServicoCampos.length >= 1) {
              this.listaDadosServicoCampos.forEach(item => {
                // Verifique se o item já existe no array (baseado em alguma propriedade, por exemplo 'idCatalogoApi')
                const itemExiste = this.listaDadosServicoCampos.some(item => item.idServicoApi === data.idServicoApi);

                // Se o item não existir, adicione-o ao array
                if (!itemExiste) {

                  this.listaDadosServicoCampos.push(data);

                  this.listaDadosServicos.forEach(dadoServico => {
                    // String original
                    const codigoString = dadoServico.codigo;

                    // Usando uma expressão regular para extrair os números do código
                    const numbers = codigoString.match(/\d+/); // Isso irá extrair todos os números da string

                    const codigo = numbers[0];

                    // setTimeout(function() {
                    //   if($(`#header-${codigo}`).find('div').length > 6 === true){
                    //     $(`#header-${codigo}`).css('display','unset');
                    //   }
                    //   if($(`#get-${codigo}`).find('div').length > 5 === true){
                    //     $(`#get-${codigo}`).css('display','unset');
                    //   }
                    //   if($(`#entrada-${codigo}`).find('div').length > 5 === true){
                    //     $(`#entrada-${codigo}`).css('display','unset');
                    //   }
                    //   if($(`#form-${codigo}`).find('div').length > 5 === true){
                    //     $(`#form-${codigo}`).css('display','unset');
                    //   }
                    //   if($(`#body-${codigo}`).find('div').length > 5 === true){
                    //     $(`#body-${codigo}`).css('display','unset');
                    //   }
                    //   if($(`#saida-${codigo}`).find('div').length > 5 === true){
                    //     $(`#saida-${codigo}`).css('display','unset');
                    //   }
                    //   if($(`#alerta-${codigo}`).find('div').length > 5 === true){
                    //     $(`#alerta-${codigo}`).css('display','unset');
                    //   }
                    //   if($(`#erro-${codigo}`).find('div').length > 5 === true){
                    //     $(`#erro-${codigo}`).css('display','unset');
                    //   }
                    // }, 100);
                  });

                  // Criando o objeto com os dados e o identificador
                  const novoItem = {
                    id: idServico,
                    atributos: data.atributos
                  };

                  this.listaDadosServicoAtributos.push(data.atributos);
                  this.listaDadosServicoAtributosHierarquia.push(novoItem);
                }
              });
            } else {
              this.listaDadosServicoCampos.push(data);

              this.listaDadosServicos.forEach(dadoServico => {
                // String original
                const codigoString = dadoServico.codigo;

                // Usando uma expressão regular para extrair os números do código
                const numbers = codigoString.match(/\d+/); // Isso irá extrair todos os números da string

                const codigo = numbers[0];

                // setTimeout(function() {
                //   if($(`#header-${codigo}`).find('div').length > 6 === true){
                //     $(`#header-${codigo}`).css('display','unset');
                //   }
                //   if($(`#get-${codigo}`).find('div').length > 5 === true){
                //     $(`#get-${codigo}`).css('display','unset');
                //   }
                //   if($(`#entrada-${codigo}`).find('div').length > 5 === true){
                //     $(`#entrada-${codigo}`).css('display','unset');
                //   }
                //   if($(`#form-${codigo}`).find('div').length > 5 === true){
                //     $(`#form-${codigo}`).css('display','unset');
                //   }
                //   if($(`#body-${codigo}`).find('div').length > 5 === true){
                //     $(`#body-${codigo}`).css('display','unset');
                //   }
                //   if($(`#saida-${codigo}`).find('div').length > 5 === true){
                //     $(`#saida-${codigo}`).css('display','unset');
                //   }
                //   if($(`#alerta-${codigo}`).find('div').length > 5 === true){
                //     $(`#alerta-${codigo}`).css('display','unset');
                //   }
                //   if($(`#erro-${codigo}`).find('div').length > 5 === true){
                //     $(`#erro-${codigo}`).css('display','unset');
                //   }
                // }, 100);
              });

              // Criando o objeto com os dados e o identificador
              const novoItem = {
                id: idServico,
                atributos: data.atributos
              };

              this.listaDadosServicoAtributos.push(data.atributos);
              this.listaDadosServicoAtributosHierarquia.push(novoItem);
            }

            loaderUtils.removeLoader();

            return data;
          })
          .catch((error) => {
            console.log(error);
          }).finally(() => 'loaderUtils.removeLoader()');

      } catch (error) {
        console.error('Erro ao realizar busca:', error);
        alertUtils.alertError('Erro ao realizar busca:' + error);
      }
    },
    async pesquisarServicoMenu(idCatalogo, codigoMenu) {
      loaderUtils.addLoarder();

      if (idCatalogo != undefined) {
        let urlApi;
        let method;
        let requestOptions;

        urlApi = '/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/servicos/' + idCatalogo + '/' + codigoMenu;
        method = 'GET';

        requestOptions = {
          method: method
        };

        try {
          fetch(urlApi, requestOptions)
            .then(async (response) => {
              if (response.ok) {
                return response.json();
              } else {
                throw new Error('Fechar');
              }
            })
            .then(async (data) => {
              this.listaDadosServicos = data;

              loaderUtils.removeLoader();

              return data;
            })
            .catch((error) => {
              console.log(error);
            }).finally(() => 'loaderUtils.removeLoader()');

        } catch (error) {
          console.error('Erro ao realizar busca:', error);
          alertUtils.alertError('Erro ao realizar busca:' + error);
        }
      }
    },
    async salvarNovoMenu() {
      try {
        this.servicoApi.idCatalogoApi = this.$route.query.idCatalogo;
        const url = `/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/incluir-servico`;

        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(this.servicoApi)
        });

        if (response.ok) {
          const result = await response.text();
          this.closeModal();
          alertUtils.alertSuccess("Menu salvo com sucesso!");
          this.$emit('onAction', this.codigo);
        } else {
          const error = await response.text();
        }
      } catch (error) {
        console.error("Erro ao salvar o serviço:", error);
      }
    },
    async salvarNovoServico() {
      this.servicoApi.idCatalogoApi = this.idCatalogo;
      this.servicoApi.codigoMenuPai = this.codigoMenuPai;
      this.servicoApi.tipo = this.menu;

      const camposObrigatorios = new Array(
        'menu', 'campo "nome" do novo serviço',
        'requestType', 'combo "Método HTTP" do novo serviço',
        'url', 'campo "URL" do novo serviço',
        'metodo', 'campo "método" do novo serviço',
        'introducao', 'campo "introdução" do novo serviço'
      );

      const erro = validadorUtils.validarCamposObrigatorios(this.servicoApi, camposObrigatorios);

      if (erro) {
        return;
      }

      const urlApi = `/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/incluir-servico`;

      const requestAjax = await ajaxUtils.postOK(
        urlApi,
        JSON.stringify(this.servicoApi),
        '',
        ''
      );



      this.closeModal();

      this.onActionInComponent();

      this.servicoApi = {
        menu: '',
        requestType: '',
        url: '',
        metodo: '',
        introducao: ''
      };

      if (requestAjax) {
        alertUtils.alertSuccess("Serviço salvo com sucesso!");
      } else {
        alertUtils.alertError("Erro ao salvar Serviço!");
      }

      return requestAjax;
    },
    async setandoVisibilidade() {
      if (this.clone === false) {
        $('.fa-trash').css("display", "none");
        $('.pen-icon').css("display", "none");
        $('.plus-icon').css("display", "none");
      } else {
        $('.fa-trash').css("display", "unset");
        $('.pen-icon').css("display", "unset");
        $('.plus-icon').css("display", "unset");
      }
    },
    getServicoAtual(codigo) {
      const servico = this.listaDadosServicoAtributosHierarquia.find(item => item.id === codigo);
      if (servico) {
        return servico;
      } else {
        return { atributos: [] }; // Retorna um objeto vazio com a propriedade atributos
      }
    }
  },
  mounted() {
    document.body.addEventListener('click', this.setandoVisibilidade);

    this.idCatalogo = this.$route.params.idCatalogo;
    if (this.idCatalogo.indexOf("-clone") != -1) {
      this.clone = true;
    }

    setTimeout(() => {
      if (this.clone === false) {
        $('.trash-icon').css("display", "none");
        $('.pen-icon').css("display", "none");
        $('.plus-icon').css("display", "none");
      }
    }, 2000); // 1000 milissegundos

    setTimeout(() => {
      if (this.clone === false) {
        $('.icon-content .plus-icon').css("display", "none");
        $('.fa-trash').css("display", "none");
        $('.plus-icon').css("display", "none");
      }
    }, 2300); // Aumentei o intervalo para evitar sobreposição

    // Acesse o hash da URL
    const hash = window.location.hash;

    // Remova a primeira barra ("/") e separe a string com base nas barras
    const idCatalogo = hash.split('/').pop();

    this.pesquisarServicoMenu(idCatalogo, this.codigo);
  },
}
</script>

<style scoped>
.input-modal {
  margin-left: 0% !important;
  width: 106% !important;
}

</style>